// import React, { useContext, useState, useEffect } from "react";
// import * as FeatherIcon from "react-feather";
// import "./Competitors.css";
// import GenericTable from "../genericComponents/genericTableComp/GenericTable";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { submitCompetitorListRequest } from "../../../store/features/actions/competitorListActions";
// import { label } from "jscharting";
// import { Link } from "react-router-dom";
// import GenericTableSkeleton from "../skeletons/tableSkeleton/genericTableSkeleton";

// export default function AllCompetitors({ user }) {
//   const url = "/comp_profile/" + user?.company_id;
//   const { clientName, competitorName } = useParams();
//   const [tableData, setTabData] = useState([]);
//   const dispatch = useDispatch();
//   const { loading, data, error } = useSelector(
//     (state) => state.competitorListReducer
//   );

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     if (user?.company_name?.length > 0) {
//       dispatch(submitCompetitorListRequest(user?.company_name));
//     }
//   }, [user]);

//   const tableColumns = [
//     { id: "competitor", label: "Competitor" },
//     { id: "region", label: "Region" },
//     { id: "revenue", label: "Revenue" },
//     // { id: "risk_level", label: "Risk Level" },
//     { id: "top_markets", label: "Top Markets" },
//     { id: "recent_moves", label: "Recent Moves", width: "600px" },
//     { id: "action", label: "", width: "120px" },
//   ];

//   useEffect(() => {
//     // console.log("COMP DATA: " + JSON.stringify(data.result));
//     if (data?.result.length > 0) {
//       const tempTabData = data?.result.map((client) => {
//         return {
//           competitor: <span className="first_comp">{client?.company}</span>,
//           region: client?.region,
//           revenue: client?.revenue,
//           // risk_level: <span className="risk_level_high">High</span>,
//           top_markets: client?.top_markets,
//           recent_moves: client?.recent_moves,
//           action: (
//             <Link
//               to={`/comp_profile/${user?.company_name}/${client?.company}`}
//               className="view_profile"
//             >
//               View Profile
//             </Link>
//           ),
//         };
//       });
//       setTabData(tempTabData);
//     }
//   }, [data]);

//   // const tableData = [
//   //   {
//   //     competitor: (
//   //       <span className="first_comp">{competitorName ?? 'Tailored Chemical Products'}</span>
//   //     ),
//   //     region: "North Carolina, USA",
//   //     revenue: "Estimated USD 90-110Mn",
//   //     // risk_level: <span className="risk_level_high">High</span>,
//   //     top_markets: "Adhesives and Specialty chemicals",
//   //     recent_moves:
//   //       "March 31, 2025: Tailored Adhesives introduced a state-of-the-art GALA pelletizer - the first of its kind in the US. This powerhouse can produce 12,000 pounds per hour.",
//   //     action: (
//   //       <Link to={url} className="view_profile">
//   //         View Profile
//   //       </Link>
//   //     ),
//   //   },
//   // ];
//   return (
//     <div
//       className="all_acccounts_wrapper"
//       style={{
//         backgroundColor: "#ffffff",
//         padding: "20px",
//         maxWidth: "99%",
//         borderRadius: "12px",
//         minHeight: "100vh",
//       }}
//     >
//       <div className="all_acccounts_block">
//         <h5 className="all_acccounts_head">
//           {/* <FeatherIcon.Briefcase className="comp_icon" /> */}
//           <span style={{ paddingRight: "5px" }}>All Competitors</span>
//           {/* <div className="pl-3 circle_ready">
//             <div id="outer-circle">
//               <div id="inner-circle"></div>
//             </div>
//           </div> */}
//         </h5>
//         <div className="d-flex toggle_block">
//           <Link
//             style={{
//               // width: "128px",
//               height: "30px",
//               top: "20px",
//               verticalAlign: "middle",
//               radius: "8px",
//               padding: "5px",
//               gap: "10px",
//               backgroundColor: "#232428",
//               weight: "600",
//               fontSize: "13px",
//               lineHeight: "16.25px",
//               color: "#FFFFFF",
//             }}
//             className="add_account_companies"
//             to="#"
//             // onClick={modalAddAccount}
//             // onClick={() => setShowMoreModal(true)}
//           >
//             <FeatherIcon.Plus className="add_icon" /> Add Competitor
//           </Link>
//         </div>
//       </div>

//       {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : (
//         <GenericTable initialColumns={tableColumns} tabData={tableData} />
//       )}
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import * as FeatherIcon from "react-feather";
// import "./Competitors.css";
// import GenericTable from "../genericComponents/genericTableComp/GenericTable";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams, Link } from "react-router-dom";
// import { submitCompetitorListRequest } from "../../../store/features/actions/competitorListActions";
// import { createCompetitorRequest } from "../../../store/features/actions/createCompetitorActions";
// import GenericTableSkeleton from "../skeletons/tableSkeleton/genericTableSkeleton";
// import { Modal, Button, Form } from "react-bootstrap";
// import Alert from "../../HtmlElements/Alert";
// import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
// import ParsedTextWithLinks from "../../HtmlElements/ParsedTextWithLinks";
// import GrowthIQSuggestions from "./GrowthIQSuggestions";

// export default function AllCompetitors({ user }) {
//   const url = "/comp_profile/" + user?.company_id;
//   const { clientName, competitorName } = useParams();
//   const [tableData, setTabData] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [competitor, setCompetitor] = useState("");
//   const [competitorInput, setCompetitorInput] = useState("");
//   const [error1, setError] = useState("");

//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   const [expandedCells, setExpandedCells] = useState({});

//   const handleToggleExpand = (rowIndex, cellIndex) => {
//     const key = `${rowIndex}-${cellIndex}`;
//     setExpandedCells((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   const dispatch = useDispatch();

//   const { loading, data } = useSelector((state) => state.competitorListReducer);
//   const { creating, success, error, status } = useSelector(
//     (state) => state.createCompetitorReducer
//   );

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     if (status?.status === "submitted") {
//       setSuccessMessage(
//         "Competitor request submitted successfully, competitor profile will be generated shortly!"
//       );
//     }

//     // if (status !== "submitted") {
//     //   setErrorMessage(
//     //     "Competitor request couldn't be submitted right now, try after some time"
//     //   );
//     // }

//     setTimeout(() => {
//       setSuccessMessage("");
//       setErrorMessage("");
//     }, 4000);
//   }, [success, status]);

//   useEffect(() => {
//     if (user?.company_name?.length > 0) {
//       dispatch(submitCompetitorListRequest(user?.company_name));
//     }
//   }, [user, dispatch]);

//   const tableColumns = [
//     { id: "competitor", label: "Competitor", width: "250px" },
//     { id: "region", label: "Region", width: "100px" },
//     { id: "revenue", label: "Revenue", width: "200px" },
//     { id: "top_markets", label: "Top Markets", width: "150px" },
//     { id: "recent_moves", label: "Recent Moves" },
//     { id: "action", label: "", width: "250px" },
//   ];

//   useEffect(() => {
//     if (data?.result?.length > 0) {
//       const tempTabData = data?.result.map((client) => {
//         return {
//           competitor: (
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <img
//                 // height="50"
//                 width="50"
//                 src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
//                   client?.company
//                 )}`}
//                 alt="image"
//                 className="all_account_icon_img mr-1"
//               />
//               <span className="first_comp">{client?.company}</span>
//             </div>
//           ),
//           region: client?.region,
//           revenue: client?.revenue,
//           top_markets: client?.top_markets,
//           recent_moves: client?.recent_moves,
//           action: client?.recent_moves,
//           action: (
//             <>
//               {!client.generating ? (
//                 <Link
//                   to={`/comp_profile/${user?.company_name}/${client?.company}`}
//                   className="view_profile"
//                 >
//                   View Profile
//                 </Link>
//               ) : (
//                 <span className="disabled-btn">Generating</span>
//               )}

//               <Link
//                 to={`/revenue_teardown/${user?.company_name}/${client?.company}`}
//                 className="revenue_teardown"
//               >
//                 Revenue Teardown
//               </Link>
//             </>
//           ),
//         };
//       });
//       setTabData(tempTabData);
//     } else {
//       setTabData([]);
//     }
//   }, [data, user]);

//   const validateCompetitorInput = (name) => {
//     if (!name.trim()) return "Competitor name cannot be empty";
//     if (name.length < 2) return "Competitor name must be at least 2 characters";
//     if (!/^[a-zA-Z0-9\s&.,'-]+$/.test(name))
//       return "Competitor name contains invalid characters";
//     return "";
//   };

//   return (
//     <div
//       className="all_acccounts_wrapper"
//       style={{
//         backgroundColor: "#ffffff",
//         padding: "20px",
//         maxWidth: "99%",
//         borderRadius: "12px",
//         minHeight: "100vh",
//       }}
//     >
//       <div className="all_acccounts_block">
//         <h5 className="all_acccounts_head">
//           <span style={{ paddingRight: "5px" }}>All Competitors</span>
//         </h5>
//         <div className="d-flex toggle_block">
//           <button
//             style={{
//               // height: "30px",
//               padding: "5px 10px",
//               backgroundColor: "#232428",
//               fontSize: "13px",
//               fontWeight: 600,
//               color: "#FFFFFF",
//               border: "none",
//               borderRadius: "6px",
//             }}
//             className="add_account_companies"
//             onClick={() => setShowModal(true)}
//           >
//             <FeatherIcon.Plus className="add_icon" /> Add Competitor
//           </button>
//         </div>
//       </div>

//       {successMessage && <Alert type="success" message={successMessage} />}
//       {errorMessage && <Alert type="danger" message={errorMessage} />}

//       {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : !loading && tableData?.length > 0 ? (
//         <>
//           {/* <GenericTable initialColumns={tableColumns} tabData={tableData} /> */}

//           {/* +++++++++++++++++++++++++++++++++++++++++++++ */}
//           <div className="competitor-list">
//             <div className="table-responsive">
//               <table className="table custom-resizable-table">
//                 <thead className="">
//                   <tr className="custom-resizable-table-header">
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Competitor
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Region
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Revenue
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Top Markets
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Recent Moves
//                       </div>
//                     </th>
//                     <th width="300px"></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {Object.values(tableData).map((competitor, rowIndex) => (
//                     <tr className="gtr-row" key={rowIndex}>
//                       {[
//                         competitor?.competitor,
//                         competitor?.region,
//                         competitor?.revenue,
//                         competitor?.top_markets,
//                         competitor?.recent_moves,
//                         competitor?.action,
//                       ].map((cellData, cellIndex) => (
//                         <td className="gtr-cell" key={cellIndex}>
//                           <div className="gtr-cell-content-container">
//                             <div
//                               className={`gtr-cell-content ${
//                                 expandedCells[`${rowIndex}-${cellIndex}`]
//                                   ? "expanded"
//                                   : ""
//                               }`}
//                               onClick={() =>
//                                 handleToggleExpand(rowIndex, cellIndex)
//                               }
//                             >
//                               {cellData !== null && cellData !== undefined && (
//                                 <ParsedTextWithLinks text={cellData} />
//                               )}
//                               {/* {cellData} */}
//                             </div>
//                           </div>
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//           {/* +++++++++++++++++++++++++++++++++++++++++++++ */}
//         </>
//       ) : (
//         <div style={{ textAlign: "center" }}>Competitors not added yet</div>
//       )}

//       {/* Add Competitor Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Add Competitor</Modal.Title>
//         </Modal.Header>
//         <Form
//           onSubmit={(e) => {
//             e.preventDefault();
//             const validationError = validateCompetitorInput(competitorInput);
//             if (validationError) {
//               setError(validationError);
//               return;
//             }
//             dispatch(
//               createCompetitorRequest({
//                 client: user?.company_name,
//                 competitor: competitorInput.trim(),
//               })
//             );
//             setShowModal(false);
//             setCompetitorInput("");
//             setError("");
//           }}
//         >
//           <Modal.Body>
//             <Form.Group>
//               <Form.Label>Competitor Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter competitor name"
//                 value={competitorInput}
//                 onChange={(e) => {
//                   setCompetitorInput(e.target.value);
//                   setError("");
//                 }}
//                 isInvalid={!!error1}
//               />
//               <div className="giq-suggest-scroll">
//                 <GrowthIQSuggestions
//                   suggestions={[]}
//                   loading={false}
//                   onSelectItem={() => {}}
//                 />
//               </div>
//               {error1 && (
//                 <Form.Control.Feedback type="invalid">
//                   {error1}
//                 </Form.Control.Feedback>
//               )}
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShowModal(false)}>
//               Cancel
//             </Button>
//             <Button type="submit" disabled={creating}>
//               {creating ? "Submitting..." : "Submit"}
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>
//     </div>
//   );
// }

// import React, { useState, useEffect } from "react";
// import * as FeatherIcon from "react-feather";
// import "./Competitors.css";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams, Link, Navigate, useNavigate } from "react-router-dom";
// import { searchCompetitor } from "../../../services/accIqService";
// import { submitCompetitorListRequest } from "../../../store/features/actions/competitorListActions";
// import { createCompetitorRequest } from "../../../store/features/actions/createCompetitorActions";
// import GenericTableSkeleton from "../skeletons/tableSkeleton/genericTableSkeleton";
// import { Modal, Button, Form } from "react-bootstrap";
// import Alert from "../../HtmlElements/Alert";
// import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
// import ParsedTextWithLinks from "../../HtmlElements/ParsedTextWithLinks";
// import GrowthIQSuggestions from "./GrowthIQSuggestions";
// import { useCompetitorContext } from "../../../context/CompetitorContext";
// import ProfileCard from "./ProfileCard/ProfileCard";
// import { getKsCompanyName } from "../../../services/commonService";
// import useAuth from "../../../hooks/useAuth";
// import { toggleCompetitorStatusRequest } from "../../../store/features/actions/competitorStatusActions";
// import APP_CONFIG from "../../../config/appConfig";
// import { createSuggestedCompetitorRequest } from "../../../store/features/actions/suggestedCompetitorActions";

// export default function AllCompetitors({ user }) {
//   useAuth();
//   const ksNameCacheRef = React.useRef({});
//   const { clientName } = useParams();
//   const { competitorInfo, setCompetitorInfo } = useCompetitorContext();
//   const navigate = useNavigate();
//   const [tableData, setTabData] = useState([]);
//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 10;
//   const indexOfLastRow = currentPage * rowsPerPage;
//   const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//   // const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);
//   // const totalPages = Math.ceil(tableData.length / rowsPerPage);
//   const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);
//   const totalPages = Math.ceil(tableData.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const endIndex = Math.min(startIndex + rowsPerPage, tableData.length);

//   const [showModal, setShowModal] = useState(false);
//   const [competitorInput, setCompetitorInput] = useState("");
//   const [error1, setError] = useState("");
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [expandedCells, setExpandedCells] = useState({});
//   const [suggestions, setSuggestions] = useState([]);
//   const [loadingSuggestions, setLoadingSuggestions] = useState(false);
//   const [selectedCompetitor, setSelectedCompetitor] = useState(null);
//   const [totalCompetitorsGenerated, setTotalCompetitorsGenerated] = useState(0);
//   const [limitExhausted, setLimitExhausted] = useState("");

//   const [showSimpleAddModal, setShowSimpleAddModal] = useState(false);
//   const [simpleCompetitorName, setSimpleCompetitorName] = useState("");

//   useEffect(() => {
//     setTotalCompetitorsGenerated(tableData?.length);
//     if (tableData?.length === user?.no_of_comp_iq_access_limit)
//       setLimitExhausted(
//         "You have exhausted the limit of competitor profile generation !!!"
//       );

//     setTimeout(() => {
//       setLimitExhausted("");
//     }, 10000);
//   }, [tableData]);

//   // Client/users restricted from adding competitor profile request as asked by Payal & Ishita
//   const restrictedClients = ["MnM AllDomains"];
//   const restrictedUsers = [
//     "dessault.demo@marketsandmarkets.com",
//     "borgwarner.demo@marketsandmarkets.com",
//     "nicolle.mirie@wacker.com",
//     "youngyeol.cho@wacker.com",
//     "timo.liebig@wacker.com",
//     "bracco.demo@marketsandmarkets.com",
//     "basf_eu.demo@marketsandmarkets.com",
//   ];
//   const dispatch = useDispatch();

//   const { loading, data } = useSelector((state) => state.competitorListReducer);
//   const hasCompetitors = Boolean(data?.result?.length);
//   const { creating, success, error, status } = useSelector(
//     (state) => state.createCompetitorReducer
//   );

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     // if (status?.competitor?.status === "submitted") {
//     if (success) {
//       setSuccessMessage(
//         "Competitor request submitted successfully, competitor profile will be generated shortly!"
//       );
//     }

//     setTimeout(() => {
//       setSuccessMessage("");
//       setErrorMessage("");
//     }, 4000);
//   }, [success, status]);

//   useEffect(() => {
//     if (user?.company_name?.length > 0) {
//       dispatch(submitCompetitorListRequest(user?.company_name_for_growth_iq));
//     }
//   }, [user, dispatch, success]);

//   const handleViewProfile = (item) => {
//     // setting the competitor info for competitor context
//     setCompetitorInfo({
//       client: item?.client,
//       competitor_name: item?.company,
//       // vendor_company_id: item?.vendor_company_id ?? "IQ398006",
//       vendor_company_id: item?.vendor_company_id ?? "",
//       ks_companies: item?.ks_companies ?? [],
//     });
//     localStorage.removeItem("localStorageCompetitorInfo");
//     localStorage.setItem(
//       "localStorageCompetitorInfo",
//       JSON.stringify({
//         client: item?.client,
//         competitor_name: item?.company,
//         vendor_company_id: item?.vendor_company_id ?? "",
//         ks_companies: item?.ks_companies ?? [],
//       })
//     );

//     // navigate(
//     //   `/comp_profile/${user?.company_name}/${encodeURIComponent(item?.company)}`
//     // );
//     // Client name updated for api call as asked by Tejas/Ishita
//     navigate(
//       `/comp_profile/${user?.company_name_for_growth_iq}/${encodeURIComponent(
//         item?.company
//       )}`
//     );
//   };

//   // useEffect(() => {
//   //   if (data?.result?.length > 0) {
//   //     const tempTabData = data?.result.map((client) => ({
//   //       competitor: (
//   //         <div style={{ display: "flex", alignItems: "center" }}>
//   //           <img
//   //             width="50"
//   //             src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
//   //               client?.company
//   //             )}`}
//   //             alt="logo"
//   //             className="all_account_icon_img mr-1"
//   //           />
//   //           <span className="first_comp">{client?.company}</span>
//   //         </div>
//   //       ),
//   //       region: client?.region,
//   //       revenue: client?.revenue,
//   //       top_markets: client?.top_markets,
//   //       recent_moves: client?.recent_moves,
//   //       action: (
//   //         <>
//   //           {!client.generating ? (
//   //             // <Link
//   //             //   to={`/comp_profile/${user?.company_name}/${client?.company}`}
//   //             //   className="view_profile"
//   //             // >
//   //             //   View Profile
//   //             // </Link>
//   //             <span
//   //               onClick={() => handleViewProfile(client)}
//   //               className="view_profile"
//   //             >
//   //               View Profile
//   //             </span>
//   //           ) : (
//   //             <span className="disabled-btn">Generating</span>
//   //           )}

//   //           <Link
//   //             to={`/revenue_teardown/${user?.company_name}/${client?.company}`}
//   //             className="revenue_teardown"
//   //           >
//   //             Revenue Teardown
//   //           </Link>
//   //         </>
//   //       ),
//   //     }));
//   //     setTabData(tempTabData);

//   //     setCurrentPage(1);
//   //   } else {
//   //     setTabData([]);
//   //   }
//   // }, [data, user]);

//   // useEffect(() => {
//   //   const buildTabData = async () => {
//   //     if (data?.result?.length > 0) {
//   //       const tempTabData = await Promise.all(
//   //         data.result.map(async (client) => {
//   //           let resolvedCompanyName = client?.company;

//   //           // 🔹 fetch from API if ks_companies exists
//   //           if (client?.ks_companies?.length > 0) {
//   //             const ksName = await getKsCompanyName(client.ks_companies[0]);
//   //             if (ksName) resolvedCompanyName = ksName;
//   //           }

//   //           return {
//   //             competitor: (
//   //               <div style={{ display: "flex", alignItems: "center" }}>
//   //                 <img
//   //                   width="50"
//   //                   src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
//   //                     resolvedCompanyName
//   //                   )}`}
//   //                   alt="logo"
//   //                   className="all_account_icon_img mr-1"
//   //                 />
//   //                 <span className="first_comp">{resolvedCompanyName}</span>
//   //               </div>
//   //             ),
//   //             region: client?.region,
//   //             revenue: client?.revenue,
//   //             top_markets: client?.top_markets,
//   //             recent_moves: client?.recent_moves,
//   //             action: (
//   //               <>
//   //                 {!client.generating ? (
//   //                   <span
//   //                     onClick={() => handleViewProfile(client)}
//   //                     className="view_profile"
//   //                   >
//   //                     View Profile
//   //                   </span>
//   //                 ) : (
//   //                   <span className="disabled-btn">Generating</span>
//   //                 )}

//   //                 <Link
//   //                   to={`/revenue_teardown/${user?.company_name}/${resolvedCompanyName}`}
//   //                   className="revenue_teardown"
//   //                 >
//   //                   Revenue Teardown
//   //                 </Link>
//   //               </>
//   //             ),
//   //           };
//   //         })
//   //       );

//   //       setTabData(tempTabData);
//   //       setCurrentPage(1);
//   //     } else {
//   //       setTabData([]);
//   //     }
//   //   };

//   //   buildTabData();
//   // }, [data, user]);

//   const handleToggleStatus = (client) => {
//     dispatch(
//       toggleCompetitorStatusRequest({
//         client: user?.company_name_for_growth_iq,
//         company: client?.company,
//         flag: false, // deactivate
//       })
//     );
//   };

//   useEffect(() => {
//     if (!data?.result?.length) {
//       setTabData([]);
//       return;
//     }

//     let isMounted = true;

//     const buildTabData = async () => {
//       const tempTabData = await Promise.all(
//         data.result
//           .filter((client) => client?.is_active !== false) // skip inactive
//           .map(async (client) => {
//             let resolvedCompanyName = client?.company;
//             const ksCode = client?.ks_companies?.[0];

//             if (ksCode) {
//               if (!ksNameCacheRef.current[ksCode]) {
//                 ksNameCacheRef.current[ksCode] = await getKsCompanyName(ksCode);
//               }
//               resolvedCompanyName =
//                 ksNameCacheRef.current[ksCode] || resolvedCompanyName;
//             }

//             return {
//               competitor: (
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <img
//                     width="50"
//                     src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
//                       resolvedCompanyName
//                     )}`}
//                     alt="logo"
//                     className="all_account_icon_img mr-1"
//                   />
//                   <span className="first_comp">{resolvedCompanyName}</span>
//                 </div>
//               ),
//               region: client?.region,
//               revenue: client?.revenue,
//               top_markets: client?.top_markets,
//               recent_moves: client?.recent_moves,
//               action: (
//                 <>
//                   {!client.generating ? (
//                     <span
//                       onClick={() => handleViewProfile(client)}
//                       className="view_profile"
//                     >
//                       View Profile
//                     </span>
//                   ) : (
//                     <span className="disabled-btn">Generating</span>
//                   )}

//                   <Link
//                     to={`/revenue_teardown/${user?.company_name}/${resolvedCompanyName}`}
//                     className="revenue_teardown"
//                   >
//                     Revenue Teardown
//                   </Link>

//                   {user?.growth_iq_role_name === "ROLE_MNM_SUBSCRIBER" &&
//                     user?.demo !== 8 && (
//                       <span
//                         className="toggle-btn ml-2"
//                         title="Deactivate competitor"
//                         onClick={() => handleToggleStatus(client)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <FeatherIcon.ToggleRight size={30} />
//                       </span>
//                     )}
//                 </>
//               ),
//             };
//           })
//       );

//       if (isMounted) {
//         setTabData(tempTabData);
//         setCurrentPage(1);
//       }
//     };

//     buildTabData();

//     return () => {
//       isMounted = false;
//     };
//   }, [data, user?.company_name]);

//   const handleToggleExpand = (rowIndex, cellIndex) => {
//     const key = `${rowIndex}-${cellIndex}`;
//     setExpandedCells((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   // API call for suggestions
//   const fetchSuggestions = async (query) => {
//     if (!query || query.length < 2) {
//       setSuggestions([]);
//       return;
//     }
//     setLoadingSuggestions(true);

//     const dummyCompanies = await searchCompetitor(query);

//     setSuggestions(dummyCompanies);
//     setLoadingSuggestions(false);
//   };

//   const handleSuggestionSelect = (item) => {
//     if (!item?.companyname) return;

//     setCompetitorInput(item.companyname);
//     setSelectedCompetitor({
//       label: item.companyname,
//       id: item.companyid,
//     });
//     setSuggestions([]);
//   };

//   const validateCompetitorInput = (name) => {
//     if (!name.trim()) return "Competitor name cannot be empty";
//     if (name.length < 2) return "Competitor name must be at least 2 characters";
//     // if (!/^[a-zA-Z0-9\s&.,'-()]+$/.test(name))
//     // if (!/^[\p{L}\p{N}\s&.,/'()\-\u2010-\u2015]+$/u.test(name))
//     if (!/^[\p{L}\p{N}\s&.,/'’()\[\]\-+\u2010-\u2015@#%|\\]+$/u.test(name))
//       return "Competitor name contains invalid characters";

//     return "";
//   };

//   const handleSimpleAddCompetitor = () => {
//     if (!simpleCompetitorName?.trim()) return;

//     dispatch(
//       createSuggestedCompetitorRequest({
//         client: user?.company_name_for_growth_iq,
//         competitor: simpleCompetitorName.trim(),
//       })
//     );

//     setShowSimpleAddModal(false);
//     setSimpleCompetitorName("");
//   };

//   const resetModalState = () => {
//     setShowModal(false);
//     setCompetitorInput("");
//     setSuggestions([]);
//     setSelectedCompetitor(null);
//     setLoadingSuggestions(false);
//     setError("");
//   };

//   return (
//     <div
//       className="all_acccounts_wrapper"
//       style={{
//         backgroundColor: "#ffffff",
//         padding: "20px",
//         maxWidth: "99%",
//         borderRadius: "12px",
//         minHeight: "100vh",
//       }}
//     >
//       <div className="all_acccounts_block">
//         <h5 className="all_acccounts_head">
//           <span style={{ paddingRight: "5px" }}>
//             {user?.company_name_for_growth_iq + " : " ??
//               user?.company_name + " : " ??
//               ""}
//             All Competitors
//           </span>
//         </h5>
//         {/* RESTRICTED FEW USERS FROM ADDING COMPETITOR PROFILE REQUEST, AS ASKED BY ISHITA */}
//         {/* {!restrictedClients.includes(user?.company_name) &&
//           !restrictedUsers.includes(user?.email) && ( */}
//         {/* {user?.demo === APP_CONFIG.market_iq_demo && */}
//         {(user?.growth_iq_role_name === "ROLE_MNM_SUBSCRIBER" ||
//           user?.demo === APP_CONFIG.market_iq_demo) &&
//           totalCompetitorsGenerated < user?.no_of_comp_iq_access_limit && (
//             <div className="d-flex toggle_block">
//               <button
//                 style={{
//                   padding: "5px 10px",
//                   backgroundColor: "#232428",
//                   fontSize: "13px",
//                   fontWeight: 600,
//                   color: "#FFFFFF",
//                   border: "none",
//                   borderRadius: "6px",
//                 }}
//                 className="add_account_companies"
//                 // onClick={() => setShowModal(true)}
//                 onClick={() => {
//                   if (APP_CONFIG.market_iq_demo === "1") {
//                     setShowSimpleAddModal(true);
//                   } else {
//                     setShowModal(true);
//                   }
//                 }}
//               >
//                 <FeatherIcon.Plus className="add_icon" /> Add Competitor
//               </button>
//             </div>
//           )}
//       </div>

//       {successMessage && <Alert type="success" message={successMessage} />}
//       {errorMessage && <Alert type="danger" message={errorMessage} />}
//       {limitExhausted && <Alert type="danger" message={limitExhausted} />}
//       {loading ? (
//         <GenericTableSkeleton colCount={3} rowCount={5} />
//       ) : // ) : !loading && tableData?.length > 0 ? (
//       !loading && hasCompetitors ? (
//         <>
//           <div className="competitor-list">
//             <div className="table-responsive">
//               <table className="table custom-resizable-table">
//                 <thead>
//                   <tr className="custom-resizable-table-header">
//                     <th>Competitor</th>
//                     <th>Region</th>
//                     <th>Revenue</th>
//                     <th>Top Markets</th>
//                     <th>Recent Moves</th>
//                     <th width="300px"></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* {Object.values(tableData).map((competitor, rowIndex) => ( */}
//                   {currentRows.map((competitor, rowIndex) => (
//                     <tr className="gtr-row" key={rowIndex}>
//                       {[
//                         competitor?.competitor,
//                         competitor?.region,
//                         competitor?.revenue,
//                         competitor?.top_markets,
//                         competitor?.recent_moves,
//                         competitor?.action,
//                       ].map((cellData, cellIndex) => (
//                         <td className="gtr-cell" key={cellIndex}>
//                           <div className="gtr-cell-content-container">
//                             <div
//                               className={`gtr-cell-content ${
//                                 expandedCells[`${rowIndex}-${cellIndex}`]
//                                   ? "expanded"
//                                   : ""
//                               }`}
//                               onClick={() =>
//                                 handleToggleExpand(rowIndex, cellIndex)
//                               }
//                             >
//                               {cellData !== null && cellData !== undefined && (
//                                 <ParsedTextWithLinks text={cellData} />
//                               )}
//                             </div>
//                           </div>
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* <div className="d-flex justify-content-end mt-3">
//             <nav>
//               <ul className="pagination">
//                 <li
//                   className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
//                 >
//                   <button
//                     className="page-link"
//                     onClick={() => setCurrentPage((prev) => prev - 1)}
//                   >
//                     Previous
//                   </button>
//                 </li>

//                 {Array.from({
//                   length: Math.ceil(tableData.length / rowsPerPage),
//                 }).map((_, i) => (
//                   <li
//                     key={i}
//                     className={`page-item ${
//                       currentPage === i + 1 ? "active" : ""
//                     }`}
//                   >
//                     <button
//                       className="page-link"
//                       onClick={() => setCurrentPage(i + 1)}
//                     >
//                       {i + 1}
//                     </button>
//                   </li>
//                 ))}

//                 <li
//                   className={`page-item ${
//                     currentPage === Math.ceil(tableData.length / rowsPerPage)
//                       ? "disabled"
//                       : ""
//                   }`}
//                 >
//                   <button
//                     className="page-link"
//                     onClick={() => setCurrentPage((prev) => prev + 1)}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div> */}

//           {totalPages > 1 && (
//             <div className="mb-3">
//               <div
//                 className="d-inline"
//                 style={{ textAlign: "center", color: "#777", fontSize: "13px" }}
//               >
//                 Showing {startIndex + 1}–{Math.min(endIndex, tableData.length)}{" "}
//                 of {tableData.length}
//               </div>

//               <div
//                 className="d-inline"
//                 style={{
//                   display: "flex",
//                   float: "right",
//                 }}
//               >
//                 {/* Previous Button */}
//                 <button
//                   className="btn btn-sm btn-light mr-1 font13"
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.max(prev - 1, 1))
//                   }
//                   disabled={currentPage === 1}
//                 >
//                   Previous
//                 </button>

//                 {/* Page Numbers */}
//                 {Array.from({ length: totalPages }, (_, i) => i + 1).map(
//                   (num) => (
//                     <button
//                       key={num}
//                       onClick={() => setCurrentPage(num)}
//                       className={`btn btn-sm mr-1 ${
//                         currentPage === num
//                           ? "btn-primary"
//                           : "btn-outline-primary-cu"
//                       }`}
//                     >
//                       {num}
//                     </button>
//                   )
//                 )}

//                 {/* Next Button */}
//                 <button
//                   className="btn btn-sm btn-light font13"
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                   }
//                   disabled={currentPage === totalPages}
//                 >
//                   Next
//                 </button>
//               </div>
//             </div>
//           )}
//         </>
//       ) : (
//         <div style={{ textAlign: "center" }}>Competitors not added yet</div>
//       )}

//       {/* Add Competitor Modal */}
//       <Modal
//         show={showModal}
//         onHide={() => {
//           resetModalState();
//           setShowModal(false);
//         }}
//         centered
//         size="lg"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Competitor</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <ProfileCard
//             user={user}
//             onSuccess={() => {
//               dispatch(
//                 submitCompetitorListRequest(user.company_name_for_growth_iq)
//               );
//               setShowModal(false);
//             }}
//           />
//         </Modal.Body>
//       </Modal>

//       <Modal
//         show={showSimpleAddModal}
//         onHide={() => {
//           setShowSimpleAddModal(false);
//           setSimpleCompetitorName("");
//         }}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Competitor</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <Form.Group>
//             <Form.Label>Competitor Name</Form.Label>
//             <Form.Control
//               type="text"
//               placeholder="Enter competitor name"
//               value={simpleCompetitorName}
//               onChange={(e) => setSimpleCompetitorName(e.target.value)}
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             // variant="secondary"
//             onClick={() => setShowSimpleAddModal(false)}
//             style={{
//               // width: "100%",
//               backgroundColor: "#4E6BCA",
//               color: "#fff",
//               padding: "0.5rem",
//               border: "none",
//               fontWeight: "600",
//               borderRadius: "8px",
//               marginBottom: "10px",
//               marginTop: "10px",
//               fontSize: "14px",
//               cursor: "pointer",
//               transition: "background-color",
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             // variant="dark"
//             className=""
//             style={{
//               // width: "100%",
//               backgroundColor: "#4E6BCA",
//               color: "#fff",
//               padding: "0.5rem",
//               border: "none",
//               fontWeight: "600",
//               borderRadius: "8px",
//               marginBottom: "10px",
//               marginTop: "10px",
//               fontSize: "14px",
//               cursor: "pointer",
//               transition: "background-color",
//             }}
//             onClick={handleSimpleAddCompetitor}
//             disabled={!simpleCompetitorName.trim()}
//           >
//             Add Competitor
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import * as FeatherIcon from "react-feather";
import "./Competitors.css";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link, Navigate, useNavigate } from "react-router-dom";
import { searchCompetitor } from "../../../services/accIqService";
import { submitCompetitorListRequest } from "../../../store/features/actions/competitorListActions";
import { createCompetitorRequest } from "../../../store/features/actions/createCompetitorActions";
import GenericTableSkeleton from "../skeletons/tableSkeleton/genericTableSkeleton";
import { Modal, Button, Form } from "react-bootstrap";
import Alert from "../../HtmlElements/Alert";
import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
import ParsedTextWithLinks from "../../HtmlElements/ParsedTextWithLinks";
import GrowthIQSuggestions from "./GrowthIQSuggestions";
import { useCompetitorContext } from "../../../context/CompetitorContext";
import ProfileCard from "./ProfileCard/ProfileCard";
import { getKsCompanyName } from "../../../services/commonService";
import useAuth from "../../../hooks/useAuth";
import { toggleCompetitorStatusRequest } from "../../../store/features/actions/competitorStatusActions";
import APP_CONFIG from "../../../config/appConfig";
import SuggestedCompetitors from "./SuggestedCompetitors";
import { createSuggestedCompetitorRequest } from "../../../store/features/actions/suggestedCompetitorActions";

export default function AllCompetitors({ user }) {
  useAuth();
  const ksNameCacheRef = React.useRef({});
  const { clientName } = useParams();
  const { competitorInfo, setCompetitorInfo } = useCompetitorContext();
  const admin_roles = ["ROLE_MNM_SUBSCRIBER", "ROLE_ACCOUNT_MANAGER"];
  const navigate = useNavigate();
  const [tableData, setTabData] = useState([]);
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  // const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);
  // const totalPages = Math.ceil(tableData.length / rowsPerPage);
  const currentRows = tableData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(tableData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, tableData.length);

  const [showModal, setShowModal] = useState(false);
  const [competitorInput, setCompetitorInput] = useState("");
  const [error1, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [expandedCells, setExpandedCells] = useState({});
  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);
  const [selectedCompetitor, setSelectedCompetitor] = useState(null);
  const [totalCompetitorsGenerated, setTotalCompetitorsGenerated] = useState(0);
  const [limitExhausted, setLimitExhausted] = useState("");
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [pendingDeactivateCompetitor, setPendingDeactivateCompetitor] =
    useState(null);

  const selectedClient = admin_roles.includes(user?.growth_iq_role_name)
    ? localStorage.getItem("selectedClient")
    : user?.company_name_for_growth_iq;

  // +++++++++++++++++++++++++++++++++++++++++
  const isMarketIQDemo = user?.demo === APP_CONFIG.market_iq_demo;
  const generationLimit = user?.no_of_comp_iq_access_limit || 0;

  const remainingSlots =
    generationLimit > 0 ? generationLimit - totalCompetitorsGenerated : 0;

  /**
   * For MarketIQ demo:
   * - Show Add buttons ONLY if limit not reached
   * - Max 3 rows at a time
   * - Remaining rows depend on remaining slots
   */
  // const addButtonRows =
  //   isMarketIQDemo && remainingSlots > 0 ? Math.min(3, remainingSlots) : 0;
  const addButtonRows =
    isMarketIQDemo && remainingSlots > 0 ? remainingSlots : 0;

  // +++++++++++++++++++++++++++++++++++++++++

  useEffect(() => {
    setTotalCompetitorsGenerated(tableData?.length);
    if (tableData?.length === user?.no_of_comp_iq_access_limit)
      setLimitExhausted(
        "You have exhausted the limit of competitor profile generation !!!"
      );

    setTimeout(() => {
      setLimitExhausted("");
    }, 5000);
  }, [tableData]);

  const dispatch = useDispatch();

  const { loading, data } = useSelector((state) => state.competitorListReducer);
  const hasCompetitors = Boolean(data?.result?.length);
  const { creating, success, error, status } = useSelector(
    (state) => state.createCompetitorReducer
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    // if (status?.competitor?.status === "submitted") {
    if (success) {
      setSuccessMessage(
        "Competitor request submitted successfully, competitor profile will be generated shortly!"
      );
    }

    setTimeout(() => {
      setSuccessMessage("");
      setErrorMessage("");
    }, 4000);
  }, [success, status]);

  useEffect(() => {
    if (user?.company_name?.length > 0) {
      dispatch(
        submitCompetitorListRequest(
          admin_roles.includes(user?.growth_iq_role_name)
            ? selectedClient
            : user?.company_name_for_growth_iq
        )
      );
    }
  }, [user, dispatch, success]);

  const handleViewProfile = (item) => {
    // setting the competitor info for competitor context
    setCompetitorInfo({
      client: item?.client,
      competitor_name: item?.company,
      // vendor_company_id: item?.vendor_company_id ?? "IQ398006",
      vendor_company_id: item?.vendor_company_id ?? "",
      ks_companies: item?.ks_companies ?? [],
    });
    localStorage.removeItem("localStorageCompetitorInfo");
    localStorage.setItem(
      "localStorageCompetitorInfo",
      JSON.stringify({
        client: item?.client,
        competitor_name: item?.company,
        vendor_company_id: item?.vendor_company_id ?? "",
        ks_companies: item?.ks_companies ?? [],
      })
    );

    navigate(
      `/comp_profile/${
        admin_roles.includes(user?.growth_iq_role_name)
          ? encodeURIComponent(selectedClient)
          : encodeURIComponent(user?.company_name_for_growth_iq)
      }/${encodeURIComponent(item?.company)}`
    );
  };

  // const handleToggleStatus = (client) => {
  //   dispatch(
  //     toggleCompetitorStatusRequest({
  //       client: admin_roles.includes(user?.growth_iq_role_name)
  //         ? selectedClient
  //         : user?.company_name_for_growth_iq,
  //       company: client?.company,
  //       flag: false, // deactivate
  //     })
  //   );
  // };

  // const handleToggleStatus = (client) => {
  //   const confirmed = window.confirm(
  //     `Are you sure you want to deactivate ${client?.company}?`
  //   );

  //   if (!confirmed) return;

  //   dispatch(
  //     toggleCompetitorStatusRequest({
  //       client: admin_roles.includes(user?.growth_iq_role_name)
  //         ? selectedClient
  //         : user?.company_name_for_growth_iq,
  //       company: client?.company,
  //       flag: false, // deactivate
  //     })
  //   );
  // };

  const handleToggleStatus = (client) => {
    setPendingDeactivateCompetitor(client);
    setShowDeactivateModal(true);
  };

  const confirmDeactivateCompetitor = () => {
    if (!pendingDeactivateCompetitor) return;

    dispatch(
      toggleCompetitorStatusRequest({
        client: admin_roles.includes(user?.growth_iq_role_name)
          ? selectedClient
          : user?.company_name_for_growth_iq,
        company: pendingDeactivateCompetitor?.company,
        flag: false, // deactivate
      })
    );

    setShowDeactivateModal(false);
    setPendingDeactivateCompetitor(null);
  };

  useEffect(() => {
    if (!data?.result?.length) {
      setTabData([]);
      return;
    }

    let isMounted = true;

    const buildTabData = async () => {
      const tempTabData = await Promise.all(
        data.result
          .filter((client) => client?.is_active !== false) // skip inactive
          .map(async (client) => {
            let resolvedCompanyName = client?.company;
            const ksCode = client?.ks_companies?.[0];

            if (ksCode) {
              if (!ksNameCacheRef.current[ksCode]) {
                ksNameCacheRef.current[ksCode] = await getKsCompanyName(ksCode);
              }
              resolvedCompanyName =
                ksNameCacheRef.current[ksCode] || resolvedCompanyName;
            }

            return {
              competitor: (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    width="50"
                    src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                      resolvedCompanyName
                    )}`}
                    alt="logo"
                    className="all_account_icon_img mr-1"
                  />
                  {/* <span className="first_comp">{resolvedCompanyName}</span> */}
                  <span className="first_comp">{client?.company}</span>
                </div>
              ),
              region: client?.region,
              revenue: client?.revenue,
              top_markets: client?.top_markets,
              recent_moves: client?.recent_moves,
              action: (
                <>
                  {!client.generating ? (
                    <span
                      onClick={() => handleViewProfile(client)}
                      className="view_profile"
                    >
                      View Profile
                    </span>
                  ) : (
                    <span className="disabled-btn">Generating</span>
                  )}

                  <Link
                    to={`/revenue_teardown/${user?.company_name}/${resolvedCompanyName}`}
                    className="revenue_teardown"
                  >
                    Revenue Teardown
                  </Link>

                  {user?.growth_iq_role_name === "ROLE_MNM_SUBSCRIBER" &&
                    user?.demo !== 8 && (
                      <span
                        className="ml-2"
                        title="Deactivate competitor"
                        onClick={() => handleToggleStatus(client)}
                        style={{ cursor: "pointer", color: "#B91C1C" }}
                      >
                        <FeatherIcon.ToggleRight
                          size={30}
                          style={{ strokeWidth: "1.5px" }}
                        />
                      </span>
                    )}
                </>
              ),
            };
          })
      );

      if (isMounted) {
        setTabData(tempTabData);
        setCurrentPage(1);
      }
    };

    buildTabData();

    return () => {
      isMounted = false;
    };
  }, [data, user?.company_name]);

  const handleToggleExpand = (rowIndex, cellIndex) => {
    const key = `${rowIndex}-${cellIndex}`;
    setExpandedCells((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // API call for suggestions
  const fetchSuggestions = async (query) => {
    if (!query || query.length < 2) {
      setSuggestions([]);
      return;
    }
    setLoadingSuggestions(true);

    const dummyCompanies = await searchCompetitor(query);

    setSuggestions(dummyCompanies);
    setLoadingSuggestions(false);
  };

  const handleSuggestionSelect = (item) => {
    if (!item?.companyname) return;

    setCompetitorInput(item.companyname);
    setSelectedCompetitor({
      label: item.companyname,
      id: item.companyid,
    });
    setSuggestions([]);
  };

  const validateCompetitorInput = (name) => {
    if (!name.trim()) return "Competitor name cannot be empty";
    if (name.length < 2) return "Competitor name must be at least 2 characters";
    // if (!/^[a-zA-Z0-9\s&.,'-()]+$/.test(name))
    // if (!/^[\p{L}\p{N}\s&.,/'()\-\u2010-\u2015]+$/u.test(name))
    if (!/^[\p{L}\p{N}\s&.,/'’()\[\]\-+\u2010-\u2015@#%|\\]+$/u.test(name))
      return "Competitor name contains invalid characters";

    return "";
  };

  const resetModalState = () => {
    setShowModal(false);
    setCompetitorInput("");
    setSuggestions([]);
    setSelectedCompetitor(null);
    setLoadingSuggestions(false);
    setError("");
  };

  const reloadGeneratedCompetitors = () => {
    if (admin_roles.includes(user?.growth_iq_role_name)) {
      dispatch(submitCompetitorListRequest(selectedClient));
    } else {
      dispatch(submitCompetitorListRequest(user?.company_name_for_growth_iq));
    }

    // if (user?.company_name_for_growth_iq?.length > 0) {
    //   dispatch(submitCompetitorListRequest(user?.company_name_for_growth_iq));
    // }
  };

  return (
    <div
      className="all_acccounts_wrapper"
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        maxWidth: "99%",
        borderRadius: "12px",
        minHeight: "100vh",
      }}
    >
      <div className="all_acccounts_block">
        <h5 className="all_acccounts_head">
          <span style={{ paddingRight: "5px" }}>
            {admin_roles.includes(user?.growth_iq_role_name)
              ? selectedClient + " : "
              : user?.company_name_for_growth_iq + " : " ??
                user?.company_name + " : " ??
                ""}
            All Competitors
          </span>
        </h5>
        {/* RESTRICTED FEW USERS FROM ADDING COMPETITOR PROFILE REQUEST, AS ASKED BY ISHITA */}
        {/* {!restrictedClients.includes(user?.company_name) &&
          !restrictedUsers.includes(user?.email) && ( */}
        {/* {user?.demo === APP_CONFIG.market_iq_demo && */}

        {/* Allowed add competitors button to client employee and client admin as asked by Virsing sir */}
        {!isMarketIQDemo &&
          (user?.growth_iq_role_name === "ROLE_MNM_SUBSCRIBER" ||
            user?.growth_iq_role_name === "ROLE_SUBSCRIBER_EMPLOYEE" ||
            user?.growth_iq_role_name === "ROLE_SUBSCRIBER_ADMIN") &&
          totalCompetitorsGenerated < user?.no_of_comp_iq_access_limit && (
            <div className="d-flex toggle_block">
              <button
                style={{
                  padding: "5px 10px",
                  backgroundColor: "#232428",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#FFFFFF",
                  border: "none",
                  borderRadius: "6px",
                }}
                className="add_account_companies"
                onClick={() => setShowModal(true)}
              >
                <FeatherIcon.Plus className="add_icon" /> Add Competitor
              </button>
            </div>
          )}
      </div>

      {successMessage && <Alert type="success" message={successMessage} />}
      {errorMessage && <Alert type="danger" message={errorMessage} />}
      {limitExhausted && <Alert type="danger" message={limitExhausted} />}
      {loading ? (
        <GenericTableSkeleton colCount={3} rowCount={5} />
      ) : // ) : !loading && tableData?.length > 0 ? (
      !loading && hasCompetitors ? (
        <>
          <div className="competitor-list">
            <div className="table-responsive">
              <table className="table custom-resizable-table">
                <thead>
                  <tr className="custom-resizable-table-header">
                    <th>Competitor</th>
                    <th>Region</th>
                    <th>Revenue</th>
                    <th>Top Markets</th>
                    <th>Recent Moves</th>
                    <th width="300px"></th>
                  </tr>
                </thead>
                <tbody>
                  {/* {Object.values(tableData).map((competitor, rowIndex) => ( */}
                  {currentRows.map((competitor, rowIndex) => (
                    <tr className="gtr-row" key={rowIndex}>
                      {[
                        competitor?.competitor,
                        competitor?.region,
                        competitor?.revenue,
                        competitor?.top_markets,
                        competitor?.recent_moves,
                        competitor?.action,
                      ].map((cellData, cellIndex) => (
                        <td className="gtr-cell" key={cellIndex}>
                          <div className="gtr-cell-content-container">
                            <div
                              className={`gtr-cell-content ${
                                expandedCells[`${rowIndex}-${cellIndex}`]
                                  ? "expanded"
                                  : ""
                              }`}
                              onClick={() =>
                                handleToggleExpand(rowIndex, cellIndex)
                              }
                            >
                              {cellData !== null && cellData !== undefined && (
                                <ParsedTextWithLinks text={cellData} />
                              )}
                            </div>
                          </div>
                        </td>
                      ))}
                    </tr>
                  ))}
                  {isMarketIQDemo &&
                    addButtonRows > 0 &&
                    Array.from({ length: addButtonRows }).map((_, idx) => (
                      <tr
                        key={`add-competitor-row-${idx}`}
                        className="gtr-row add-competitor-row"
                      >
                        <td colSpan={6} style={{ textAlign: "left" }}>
                          <button
                            className="add_account_companies"
                            style={{
                              padding: "5px 10px",
                              backgroundColor: "#232428",
                              fontSize: "13px",
                              fontWeight: 600,
                              color: "#FFFFFF",
                              border: "none",
                              borderRadius: "6px",
                            }}
                            onClick={() => setShowModal(true)}
                          >
                            <FeatherIcon.Plus size={14} className="mr-1" />
                            Add Competitor
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {totalPages > 1 && (
            <div className="mb-3">
              <div
                className="d-inline"
                style={{ textAlign: "center", color: "#777", fontSize: "13px" }}
              >
                Showing {startIndex + 1}–{Math.min(endIndex, tableData.length)}{" "}
                of {tableData.length}
              </div>

              <div
                className="d-inline"
                style={{
                  display: "flex",
                  float: "right",
                }}
              >
                {/* Previous Button */}
                <button
                  className="btn btn-sm btn-light mr-1 font13"
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  Previous
                </button>

                {/* Page Numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                  (num) => (
                    <button
                      key={num}
                      onClick={() => setCurrentPage(num)}
                      className={`btn btn-sm mr-1 ${
                        currentPage === num
                          ? "btn-primary"
                          : "btn-outline-primary-cu"
                      }`}
                    >
                      {num}
                    </button>
                  )
                )}

                {/* Next Button */}
                <button
                  className="btn btn-sm btn-light font13"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </>
      ) : (
        <div style={{ textAlign: "center" }}>Competitors not added yet</div>
      )}

      {(admin_roles.includes(user?.growth_iq_role_name) ||
        user?.demo === APP_CONFIG.market_iq_demo) && (
        <SuggestedCompetitors
          totalCompetitorsGenerated={totalCompetitorsGenerated}
          user={user}
          generatedCompetitors={data}
          reloadGeneratedCompetitors={reloadGeneratedCompetitors}
        />
      )}

      {/* Add Competitor Modal */}
      <Modal
        show={showModal}
        onHide={() => {
          resetModalState();
          setShowModal(false);
        }}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Competitor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ProfileCard
            user={user}
            onSuccess={() => {
              dispatch(
                submitCompetitorListRequest(
                  admin_roles.includes(user?.growth_iq_role_name)
                    ? selectedClient
                    : user.company_name_for_growth_iq
                )
              );
              setShowModal(false);
            }}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showDeactivateModal}
        onHide={() => {
          setShowDeactivateModal(false);
          setPendingDeactivateCompetitor(null);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deactivate Competitor</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            Are you sure you want to deactivate{" "}
            <strong>{pendingDeactivateCompetitor?.company}</strong>?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="profile-card-button"
            onClick={() => {
              setShowDeactivateModal(false);
              setPendingDeactivateCompetitor(null);
            }}
          >
            Cancel
          </button>

          <button
            className="profile-card-button profile-card-button-primary"
            onClick={confirmDeactivateCompetitor}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
